import { ProductType } from "./models"

const queryKeys = {
  cartContext: (resortId: number) => ["cartContext", resortId],
  banners: (resortId: number, formattedDate: string) => [
    "banners",
    resortId,
    formattedDate,
  ],
  resorts: ["resorts"],
  webAdminTranslations: (resortId: number, date: string, language: string) => [
    "webAdminTranslations",
    resortId,
    date,
    language,
  ],
  categories: (
    resortId: number | undefined,
    startDate: string,
    partnerCode: string | null
  ) => ["categories", resortId, startDate, partnerCode],
  bookingLengths: (
    resortId: number | undefined,
    webCategory: number | undefined,
    arrivalDate: string,
    partnerCode: string | null
  ) => ["bookingLengths", resortId, webCategory, arrivalDate, partnerCode],
  products: (params: {
    resortId: number | undefined
    arrivalDate: string
    categoryId: number | undefined
    encodedProductIds: string
    partnerCode: string | null
  }) => [
    "products",
    params.resortId,
    params.arrivalDate,
    params.categoryId,
    params.encodedProductIds,
    params.partnerCode,
  ],
  prices: (params: {
    arrivalDate: string
    productIds: string[]
    productTypeId: ProductType
    categoryId: number
  }) => [
    "prices",
    params.arrivalDate,
    params.productIds,
    params.productTypeId,
    params.categoryId,
  ],
  priceSummary: (resortId: number | undefined, arrivalDate: string) => [
    "priceSummary",
    resortId,
    arrivalDate,
  ],
  userCards: ["userCards"],
  guests: ["guests"],
  capacities: (params: { capacityGroupIds: string[] }) => [
    "capacities",
    params.capacityGroupIds,
  ],
  wtpValidation: (params: {
    resortId: number
    wtpNumber: string | undefined
    isUserProfileCard: boolean
  }) => [
    "wtpValidation",
    params.resortId,
    params.wtpNumber,
    params.isUserProfileCard,
  ],
  cardPrice: (productId: string, formattedDate: string, resortId: number) => [
    "card-price",
    productId,
    formattedDate,
    resortId,
  ],
  dateRangeAdvisory: (resortId: number, date: string) => [
    "dateRangeAdvisory",
    resortId,
    date,
  ],
  salePeriod: (resortId: number) => ["saleperiod", resortId],
  cartUsers: (resortExternalId: number, date: string) => [
    "cartUsers",
    resortExternalId,
    date,
  ],
  editPass: (cartItemId: string) => ["editPass", cartItemId],
  unavailableDatesPerCategory: (
    resortId: number | undefined,
    categoryId: number | undefined,
    year: number,
    month: number
  ) => ["unavailableDatesPerCategory", resortId, categoryId, year, month],
}

export default queryKeys
